<script setup>
import VehicleGrid from '@/components/registry/VehicleGrid.vue'
</script>
<template>
  <vehicle-grid />
</template>
